import {
  Field,
  FieldArray,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import React, { useEffect, useRef, useState } from "react";
import ShadowCard from "../../components/common/ShadowCard";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Typography } from "@progress/kendo-react-common";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { Button } from "@progress/kendo-react-buttons";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import FormDatePicker from "../../components/formFields/FormDateField";
import { useLocation, useNavigate } from "react-router-dom";
import { createGhat, getGhatById, updateGhat } from "./services/ghat.services";
import {
  clearGhatDetail,
  setGhatOrderItemIndex,
  setGhatOrderSave,
} from "./ghatSlice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import moment from "moment";
import { closed } from "../../components/muidrawer/muiDrawerSlice";
import { RootState } from "../../app/store";
import {
  getKarigarListByProcess,
  getKarigarStock,
  getViewKarigarStock,
} from "../karigar/services/karigar.services";
import { LoadingPanel } from "../../components/layout/Loading";
import FormTextField from "../../components/formFields/FormTextField";
import { IKarigarListByProcess } from "../karigar/karigarModel";
import FormNumericTextField from "../../components/formFields/FormNumericTextField";
import { findAllActiveItem } from "../item/services/item.services";
import { findAllActivePurity } from "../purity/services/purity.services";
import { findAllActiveItemCategory } from "../itemcategory/services/itemcategory.services";
import { findAllActiveProcess } from "../process/services/process.services";
import { clearOrderDetail } from "../order/orderSlice";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";

import GhatOrderDetailArray from "./GhatOrderDetailArray";
import { findAllActiveUnit } from "../unit/services/unit.services";
import GhatOrderListArray from "./GhatOrderListArray";
import GoldIssueDetailArray from "./GoldIssueDetailArray";
import FormTextArea from "../../components/formFields/FormTextArea";
import { CustomAppDrawer } from "../../components/muidrawer/Drawer";
import CreateUnit from "../unit/CreateUnit";
import { closeUnitDrawerOpen } from "../unit/unitSlice";
import { clearItemDetail } from "../item/itemSlice";
import { PRINT_ACCESS, PROCESS_ID } from "../../_contstants/common";
import Tooltip from "@mui/material/Tooltip";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { clearKarigarStock } from "../karigar/karigarSlice";
import {
  checkAcessRights,
  formatToIndianCurrencyWithoutSymbol,
  formatWeight,
} from "../../_helper/helper";
import { ErrorToast } from "../../components/toast/Toasts";
import { FaEye } from "react-icons/fa";
import AppDialog from "../../components/dialog/Dialog";
import { ImCross } from "react-icons/im";

interface FormChangeWatcherProps {
  formRenderProps: FormRenderProps;
}
const KarigarChangeWatcher: React.FC<FormChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const dispatch = useAppDispatch();
  const karigar_id = formRenderProps.valueGetter("karigar_id");
  const KarigarList = useAppSelector(
    (state) => state.karigar?.KarigarListByProcess,
  );
  const ghat_gold_issues = formRenderProps.valueGetter("ghat_gold_issues");

  const fetchKarigarStock = async (karigar_id: number) => {
    await dispatch(getKarigarStock(karigar_id));
  };
  useEffect(() => {
    if (karigar_id) {
      fetchKarigarStock(karigar_id);
      dispatch(getViewKarigarStock(karigar_id));
    }
  }, [karigar_id]);

  useEffect(() => {
    if (karigar_id && KarigarList?.length > 0) {
      const selectedKarigar = KarigarList.find(
        (karigar) => karigar.karigar_id === karigar_id,
      );
      if (selectedKarigar) {
        const wastage = selectedKarigar?.wastage;
        const wastage_type = selectedKarigar?.wastage_type;

        formRenderProps.onChange(`karigar_given_wastage`, {
          value: wastage || 0,
        });
        formRenderProps.onChange(`karigar_given_wastage_type`, {
          value: wastage_type,
        });

        // ghat_gold_issues?.forEach((element: any, index: number) => {
        //   formRenderProps.onChange(`ghat_gold_issues.${index}.given_wastage`, {
        //     value: wastage || 0,
        //   });
        //   formRenderProps.onChange(
        //     `ghat_gold_issues.${index}.given_wastage_type`,
        //     { value: wastage_type }
        //   );
        // });
      }
    }
  }, [karigar_id, ghat_gold_issues, KarigarList]);

  return null;
};

const TotalChangeWatcher: React.FC<FormChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const GhatItems = formRenderProps.valueGetter("ghat_gold_issues");

  let weight_total = 0;
  let phine_total = 0;
  let pcs_total = 0;
  useEffect(() => {
    if (GhatItems && GhatItems.length > 0) {
      GhatItems?.map((item: any) => {
        weight_total += +item.given_weight;
        phine_total += +item.phine;
        pcs_total += +item.pcs;
      });
    }
    formRenderProps.onChange(`weight_total`, {
      value: weight_total || "",
    });
    formRenderProps.onChange(`phine_total`, {
      value: phine_total.toFixed(3) || "",
    });
    formRenderProps.onChange(`pcs_total`, {
      value: pcs_total || "",
    });
  }, [
    GhatItems?.map((item: any) => item?.given_weight).join("-"),
    GhatItems?.map((item: any) => item?.phine).join("-"),
    GhatItems?.map((item: any) => item?.pcs).join("-"),
  ]);
  return null;
};

const CreateGhat: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const isPrintAccess = checkAcessRights(
    "/" + location.pathname.split("/")[1],
    PRINT_ACCESS,
  );
  const gridRef = useRef<any>(null);

  const ViewKarigarStock = useAppSelector(
    (state) => state.karigar?.ViewKarigarStock,
  );
  const ghat_guid = location?.state?.ghat_guid;

  const loading = useAppSelector((state) => state.ghat?.loading);
  const GhatOrderSave = useAppSelector((state) => state.ghat?.GhatOrderSave);
  const karigarStock = useAppSelector((state) => state.karigar.KarigarStock);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);

  const KarigarListByProcess = useAppSelector(
    (state) => state.karigar?.KarigarListByProcess,
  );

  const unitDrawerOpen = useAppSelector((state) => state.unit.unitDrawerOpen);

  const GhatDetail = useAppSelector(
    (state: RootState) => state.ghat.GhatDetail,
  );

  const [formKey, setFormKey] = useState(1);

  const today = new Date();
  const maxDate =
    new Date(today.getFullYear(), today.getMonth(), today.getDate()) || null;

  useEffect(() => {
    dispatch(getKarigarListByProcess(PROCESS_ID.ghat));
    dispatch(findAllActiveItem());
    dispatch(findAllActiveUnit());
    dispatch(findAllActivePurity());
    dispatch(findAllActiveItemCategory());
    dispatch(findAllActiveProcess());
    return () => {
      dispatch(clearGhatDetail());
      dispatch(clearOrderDetail());
      dispatch(clearItemDetail());
      dispatch(clearKarigarStock());
    };
  }, []);

  useEffect(() => {
    if (ghat_guid) {
      dispatch(getGhatById(ghat_guid));
      dispatch(closed());
    }
  }, [ghat_guid]);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [GhatDetail]);

  const handleSubmit = async (values: any) => {
    if (GhatOrderSave) {
      return null;
    }
    if (!(values.ghat_gold_issues.length || values.ghat_item.length)) {
      ErrorToast(
        "Either Order Entry or Gold Issue Entry must be compulsory before saving the record.",
      );
      return;
    }
    const formData = {
      karigar_id: values.karigar_id ? +values.karigar_id : 0,
      issue_date: values.issue_date
        ? moment(values.issue_date).format("YYYY-MM-DD")
        : "",
      // approx_delivery_date: values.approx_delivery_date
      //   ? moment(values.approx_delivery_date).format("YYYY-MM-DD")
      //   : null,
      given_amount: values?.given_amount,
      remarks: values.remarks,
      isactive: true,
      ghat_item: values.ghat_item
        ? values.ghat_item.map((ghat_info: any) => {
            return {
              id: ghat_info.id ? ghat_info.id : 0,
              order_id: ghat_info.order_id ? +ghat_info.order_id : null,
              item_id: ghat_info.item_id ? +ghat_info.item_id : null,
              item_category_id: ghat_info.item_category_id
                ? +ghat_info.item_category_id
                : null,
              purity_id: ghat_info.purity_id ? +ghat_info.purity_id : null,
              approx_delivery_date: ghat_info.approx_delivery_date
                ? moment(ghat_info.approx_delivery_date).format("YYYY-MM-DD")
                : null,
              weight: ghat_info.weight ? +ghat_info.weight : 0,
              remarks: ghat_info.remarks,
              order_no: ghat_info.order_no ? +ghat_info.order_no : null,
              process_id: ghat_info.process_id ? +ghat_info.process_id : null,
              approval_items: ghat_info.approval_items
                ? ghat_info.approval_items?.map((approve: any) => {
                    return {
                      id: approve?.id ? approve.id : 0,
                      order_id: approve?.order_id
                        ? +approve.order_id
                        : +ghat_info.order_id
                          ? +ghat_info.order_id
                          : null,
                      IssueDate: approve.IssueDate
                        ? moment(approve.IssueDate).format("YYYY-MM-DD")
                        : null,
                      type: approve?.type ? approve.type : "",
                      item_id: approve?.item_id ? +approve.item_id : null,
                      weight: approve?.weight ? +approve.weight : 0,
                      qty: approve?.qty ? +approve.qty : 0,
                      unit_id: approve?.unit_id ? +approve.unit_id : null,
                      remarks: approve?.remarks ? approve.remarks : "",
                    };
                  })
                : [],
            };
          })
        : [],
      ghat_gold_issues: values.ghat_gold_issues
        ? values.ghat_gold_issues.map((gold_issue: any) => {
            return {
              id: gold_issue.id ? gold_issue.id : 0,
              item_id: gold_issue.item_id ? gold_issue.item_id : 0,
              IssueDate: gold_issue.IssueDate
                ? moment(gold_issue.IssueDate).format("YYYY-MM-DD")
                : null,
              given_weight: gold_issue.given_weight
                ? +gold_issue.given_weight
                : 0,
              given_purity: gold_issue.given_purity
                ? +gold_issue.given_purity
                : 0,
              given_wastage: gold_issue.given_wastage
                ? +gold_issue.given_wastage
                : 0,
              phine: gold_issue.phine ? +gold_issue.phine : 0,
              pcs: gold_issue.pcs ? +gold_issue.pcs : 0,
            };
          })
        : [],
    };
    if (ghat_guid) {
      const editPayload = {
        ghat_guid: ghat_guid,
        issue_no: values.issue_no,
        ...formData,
      };
      try {
        const response = await dispatch(updateGhat(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          navigate("/ghatissue");
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    } else {
      try {
        const response = await dispatch(createGhat(formData));
        if (response?.meta?.requestStatus === "fulfilled") {
          navigate("/ghatissue");
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    }
  };
  const handleFormClose = () => {
    navigate("/ghatissue");
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      {unitDrawerOpen && (
        <CustomAppDrawer
          open={unitDrawerOpen}
          closeDrawerFunction={closeUnitDrawerOpen}
        >
          <CreateUnit />
        </CustomAppDrawer>
      )}
      {dialogName === "viewKarigarStock" && (
        <>
          <AppDialog>
            <div>
              <div className="d-flex justify-content-between">
                <Typography.h4>Karigar Stock</Typography.h4>
                <div
                  style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "50%",
                    backgroundColor: "#e53e3e",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                  }}
                  onClick={() => {
                    dispatch(closeDialog());
                  }}
                >
                  <ImCross style={{ color: "white", fontSize: "14px" }} />
                </div>
              </div>
              <div className="stock-container">
                <div className="stock-item w-100">
                  <div className="stock-header">
                    <div
                      className={`indicator-dot amount-dot-${karigarStock.Amount_credit_debit}`}
                    ></div>
                    <Typography.h6 className="stock-label">
                      Amount Balance
                    </Typography.h6>
                  </div>
                  <Typography.h6
                    className={`stock-value amount-value-${karigarStock.Amount_credit_debit}`}
                  >
                    ₹
                    {formatToIndianCurrencyWithoutSymbol(
                      karigarStock.amount || 0,
                    )}{" "}
                    <span
                      style={{
                        fontWeight: "normal",
                        textTransform: "capitalize",
                        fontSize: 16,
                      }}
                    >
                      {karigarStock.Amount_credit_debit}
                    </span>
                  </Typography.h6>
                </div>

                <div className="stock-item  w-100">
                  <div className="stock-header">
                    <div
                      className={`indicator-dot phine-dot-${karigarStock.phine_credit_debit}`}
                    ></div>
                    <Typography.h6 className="stock-label">
                      Phine (gm) Stock
                    </Typography.h6>
                  </div>
                  <Typography.h6
                    className={`stock-value phine-value-${karigarStock.phine_credit_debit}`}
                  >
                    {formatWeight(karigarStock.phine)}{" "}
                    <span
                      style={{
                        fontWeight: "normal",
                        textTransform: "capitalize",
                        fontSize: 16,
                      }}
                    >
                      {karigarStock.phine_credit_debit}
                    </span>
                  </Typography.h6>
                </div>
              </div>
              <div
                className="table-responsive"
                style={{
                  maxHeight: "30vh",
                  scrollbarWidth: "thin",
                  marginTop: 10,
                }}
              >
                <table
                  className="table table-striped table-bordered table-hover field-array-table"
                  style={{ minWidth: 500 }}
                >
                  <thead>
                    <tr>
                      <th>Item Name</th>
                      <th>Qty</th>
                      <th>Weight (gm)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ViewKarigarStock?.map((item, index) => (
                      <tr key={index}>
                        <td>{item?.product_name}</td>
                        <td>{item?.actual_qty}</td>
                        <td>{item?.actual_weight}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </AppDialog>
        </>
      )}
      <Form
        onSubmit={handleSubmit}
        key={formKey}
        initialValues={GhatDetail}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <KarigarChangeWatcher formRenderProps={formRenderProps} />
            <ShadowCard style={{ padding: 12 }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "33.33%" },
                  { width: "33.33%" },
                  { width: "33.33%" },
                ]}
              >
                <GridLayoutItem colSpan={3}>
                  <Typography.h4>
                    {ghat_guid ? "Update Ghat Issue" : "Create Ghat Issue"}
                  </Typography.h4>
                </GridLayoutItem>
                <GridLayoutItem colSpan={3}>
                  {ghat_guid ? (
                    <Typography.h5>
                      Ghat No :{" "}
                      <span style={{ color: "green" }}>
                        {GhatDetail.issue_no}
                      </span>
                    </Typography.h5>
                  ) : (
                    ""
                  )}
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="karigar_id"
                    label="Karigar Name"
                    placeholder="Select Karigar"
                    isAddNew={true}
                    addNewLink="karigar/create"
                    dispatcherFunction={getKarigarListByProcess}
                    dispatcherFunctionPayload={PROCESS_ID.ghat}
                    component={FormSelectionField}
                    validator={requiredValidator}
                    astrike={true}
                    options={KarigarListByProcess?.map(
                      (karigar: IKarigarListByProcess) => {
                        return {
                          value: karigar?.karigar_id,
                          label: `${karigar?.karigar_nick_name || karigar?.karigar_name}`,
                        };
                      },
                    )}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="issue_date"
                    label="Issue Date"
                    placeholder="day/month/year"
                    format={"dd/MM/yyyy"}
                    component={FormDatePicker}
                    max={maxDate}
                    value={new Date()}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                {/* <GridLayoutItem>
                  <Field
                    name="approx_delivery_date"
                    label="Approx Delivery Date"
                    format={"dd/MM/yyyy"}
                    placeholder="day/month/year"
                    component={FormDatePicker}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem> */}
              </GridLayout>
            </ShadowCard>

            {loading ? (
              <LoadingPanel gridRef={gridRef} />
            ) : (
              <ShadowCard style={{ marginTop: 10 }}>
                <Typography.h4>Order List</Typography.h4>
                {formRenderProps.valueGetter("ghat_item")?.length > 0 ? (
                  <FieldArray
                    formRenderProps={formRenderProps}
                    component={GhatOrderListArray}
                    name="ghat_item"
                  />
                ) : (
                  <></>
                )}
                <div style={{ marginTop: 10 }}>
                  <Button
                    type="button"
                    themeColor={"primary"}
                    onClick={() => {
                      dispatch(openDialog("show-ghat-items-dialog"));
                      dispatch(setGhatOrderItemIndex(999));
                      dispatch(setGhatOrderSave(true));
                    }}
                    fillMode="solid"
                  >
                    Add New Order
                  </Button>
                </div>
                <FieldArray
                  formRenderProps={formRenderProps}
                  component={GhatOrderDetailArray}
                  name="ghat_item"
                />
              </ShadowCard>
            )}
            <TotalChangeWatcher formRenderProps={formRenderProps} />
            <ShadowCard style={{ marginTop: 10 }}>
              <GridLayoutItem
                colSpan={4}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography.h4 style={{ margin: 0 }}>
                  Gold Issue Detail
                </Typography.h4>
                <Tooltip
                  placement="top"
                  title={
                    <>
                      <Typography.h6>
                        1. Phine (gm) = Weight (gm) X ( ( Purity + Wastage ) /
                        100 ) If Wastage in Percentage ( % )
                      </Typography.h6>
                      <Typography.h6>
                        2. Phine (gm) = Weight (gm) X ( Purity / 100 ) + Wastage
                        If Wastage in Rupees ( ₹ )
                      </Typography.h6>
                    </>
                  }
                >
                  <IoMdInformationCircleOutline
                    style={{ fontSize: "24px", color: "red" }}
                  />
                </Tooltip>
              </GridLayoutItem>
              <FieldArray
                formRenderProps={formRenderProps}
                component={GoldIssueDetailArray}
                name="ghat_gold_issues"
              />

              <div>
                <Button
                  type="button"
                  themeColor={"primary"}
                  onClick={() => dispatch(openDialog("viewKarigarStock"))}
                >
                  <FaEye fontSize={18} /> View Stock
                </Button>
              </div>
              {formRenderProps.valueGetter("ghat_gold_issues")?.length > 0 && (
                <GridLayout
                  style={{ marginRight: 40 }}
                  gap={{ rows: 0, cols: 10 }}
                  cols={[
                    { width: "20%" },
                    { width: "20%" },
                    { width: "20%" },
                    { width: "20%" },
                    { width: "20%" },
                  ]}
                >
                  <GridLayoutItem col={3}>
                    <Field
                      name="weight_total"
                      label="Total Given Weight (gm)"
                      format="n3"
                      placeholder="0.000"
                      type="number"
                      component={FormNumericTextField}
                      disabled
                    />
                  </GridLayoutItem>
                  <GridLayoutItem col={4}>
                    <Field
                      name="phine_total"
                      label="Total Phine (gm)"
                      component={FormTextField}
                      placeholder="0"
                      disabled
                    />
                  </GridLayoutItem>
                  <GridLayoutItem col={5}>
                    <Field
                      name="pcs_total"
                      label="Total PCS"
                      placeholder="0"
                      component={FormTextField}
                      disabled
                    />
                  </GridLayoutItem>
                </GridLayout>
              )}
            </ShadowCard>
            <ShadowCard style={{ marginTop: 10 }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "33.33%" },
                  { width: "33.33%" },
                  { width: "33.33%" },
                ]}
              >
                <GridLayoutItem colSpan={2}>
                  <Field
                    rows={2}
                    name="remarks"
                    label="Remarks"
                    placeholder="Write Here..."
                    component={FormTextArea}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="given_amount"
                    label="Given Amount"
                    placeholder="0"
                    type="number"
                    component={FormTextField}
                  />
                </GridLayoutItem>
                <GridLayoutItem
                  colSpan={3}
                  style={{
                    textAlign: "end",
                    marginTop: "20px",
                    width: "100%",
                  }}
                >
                  {isPrintAccess && ghat_guid && (
                    <Button
                      type="button"
                      style={{ marginRight: 4 }}
                      fillMode={"solid"}
                      themeColor={"primary"}
                      onClick={() =>
                        window.open(`/ghatissue/${ghat_guid}`, "_blank")
                      }
                    >
                      <FaEye style={{ fontSize: "18" }} /> View Report
                    </Button>
                  )}
                  <Button
                    type="button"
                    fillMode={"solid"}
                    themeColor={"primary"}
                    style={{ marginRight: 4 }}
                    onClick={handleFormClose}
                  >
                    Go To Ghat Issue List
                  </Button>
                  <ButtonWithLoading
                    label={!ghat_guid ? "Create" : "Update"}
                    type="submit"
                    disabled={!formRenderProps.allowSubmit || loading}
                    loading={loading}
                  />
                  <Button
                    type="button"
                    fillMode={"outline"}
                    themeColor={"primary"}
                    style={{ marginLeft: 4 }}
                    onClick={handleFormClose}
                  >
                    Cancel
                  </Button>
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
          </FormElement>
        )}
      />
    </>
  );
};

export default CreateGhat;
